import { render, staticRenderFns } from "./BrigadeAutoAssignConfig.vue?vue&type=template&id=7f8fab8c&"
import script from "./BrigadeAutoAssignConfig.vue?vue&type=script&lang=js&"
export * from "./BrigadeAutoAssignConfig.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeAutoAssignConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField} from 'quasar'
component.options.components = Object.assign({QField}, component.options.components || {})
